/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  BulkRegistrationStarted,
  ProblemDetails
} from '../../models';

import { apiMutator } from '../../../http/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Verifies the upload, pins it, checks its header and hands it to the import coordinator.
 * @summary Start processing an uploaded bulk registration file
 */
export const startBulkRegistration = (
    id: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<BulkRegistrationStarted>(
      {url: `/v1/devices/bulk-registrations/${id}/start`, method: 'POST', signal
    },
      options);
    }




export const getStartBulkRegistrationMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startBulkRegistration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof startBulkRegistration>>, TError,{id: string}, TContext> => {

const mutationKey = ['startBulkRegistration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startBulkRegistration>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  startBulkRegistration(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartBulkRegistrationMutationResult = NonNullable<Awaited<ReturnType<typeof startBulkRegistration>>>

    export type StartBulkRegistrationMutationError = ProblemDetails

    /**
 * @summary Start processing an uploaded bulk registration file
 */
export const useStartBulkRegistration = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startBulkRegistration>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startBulkRegistration>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getStartBulkRegistrationMutationOptions(options), queryClient);
    }
